'use client';

import Image from '@/shared/ui/atoms/Image';
import Link from 'next/link';
import { useEffect } from 'react';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		// Keep a console signal for debugging prod-only crashes
		// eslint-disable-next-line no-console
		console.error(error);
	}, [error]);

	return (
		<section className="box flex flex-col items-center justify-center py-28 text-center">
			<div className="relative w-[180px] h-[180px] md:w-[220px] md:h-[220px] overflow-hidden flex items-center justify-center">
				<Image
					src="/images/alarm.gif"
					alt="Ajansspor - Hata"
					width={150}
					height={150}
					priority
					unoptimized
					className="object-contain"
				/>
			</div>

			<div className="mt-14 text-center">
				<h1 className="text-2xl font-bold">Bir şeyler çok ters gitti</h1>
				<p className="text-sm text-gray-500 mt-2">Bu hatayı araştırıyoruz. Lütfen biraz sonra tekrar deneyin.</p>
			</div>

			{error?.digest ? (
				<p className="mt-3 text-xs text-gray-500">
					Hata kodu: <span className="font-mono">{error.digest}</span>
				</p>
			) : null}

			<div className="mt-6 flex flex-col sm:flex-row gap-3">
				<button
					type="button"
					onClick={() => reset()}
					className="px-5 py-2 rounded bg-brand-primary text-white font-semibold hover:opacity-90 transition-opacity"
				>
					Tekrar dene
				</button>
				<Link
					href="/"
					className="px-5 py-2 rounded border border-border text-text-primary font-semibold hover:bg-card-surface transition-colors"
				>
					Ana sayfa
				</Link>
			</div>
		</section>
	);
}
